/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import FormBlock from 'loracoms/FormBlock';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import deviceActions from 'loraactions/device';
import { isHexString } from 'lorautils/checkers/numbers';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  sendCmd: React.PropTypes.func.isRequired,
  sent: React.PropTypes.object.isRequired,
};

class AddBroadcastReqV2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'devaddr')
          .add('FE_EMPTY', 'nwkskey')
          .add('FE_EMPTY', 'appskey')
          .add('FE_EMPTY', 'fcnt')
      ),
      appskey: '',
      nwkskey: '',
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview');
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { sent } = nextProps;
    this.setState({ sentStatus: sent.status });
    if (sent.error) {
      const { code, message = '' } = sent.error;
      this.setState({
        errors: this.state.errors.add(`${code}_${message.toUpperCase()}`, 'submit'),
      });
    }
  }

  checkAddr(key, val, errors = this.state.errors) {
    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!isHexString(val, { len: 8 })) {
      return errors.add(
        'FE_INVALIDADDR',
        key,
        { message: this.intlMsg.errorMsg('FE_INVALIDADDR') },
      );
    }
    return errors.remove(key);
  }

  handleChangeDevaddr(e) {
    let val = _.trim(e.target.value);
    val = val.replace(/:|-/g, '');
    let { errors } = this.state;
    errors = this.checkAddr('devaddr', val, errors);
    this.setState({ errors, devaddr: val });
  }

  checkKeys(key, val, errors = this.state.errors) {
    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!isHexString(val, { len: 32 })) {
      return errors.add(
        'FE_INVALIDAPPKEY',
        key,
        { message: this.intlMsg.errorMsg('FE_INVALIDAPPKEY') },
      );
    }
    return errors.remove(key);
  }

  handleChangeKeys(key, e) {
    const val = _.trim(e.target.value);
    let { errors } = this.state;
    errors = this.checkKeys(key, val, errors);
    this.setState({ errors, [key]: val });
  }

  handleChangeFcnt(e) {
    let { errors } = this.state;
    const fcnt = _.trim(e.target.value);
    if (fcnt.length === 0) {
      errors = errors.add('FE_EMPTY', 'fcnt');
    } else if (!_.isInteger(Number(fcnt))) {
      errors = errors.add('INVALID_FCNT', 'fcnt');
    } else {
      errors = errors.remove('fcnt');
    }
    this.setState({ errors, fcnt });
  }

  handleSubmit(e) {
    e.preventDefault();
    let { errors } = this.state;
    errors = errors.remove('submit');
    this.setState({ submitted: true, errors });

    if (!errors.isEmpty()) {
      return;
    }

    const { deviceId, sendCmd } = this.props;
    const { devaddr, nwkskey, appskey, fcnt } = this.state;
    sendCmd(deviceId, {
      devaddr,
      nwkskey,
      appskey,
      fcnt: Number(fcnt),
    });
  }

  render() {
    const {
      sentStatus = '',
      devaddr = '',
      nwkskey = '',
      appskey = '',
      errors,
      submitted = false,
      fcnt = '',
    } = this.state;

    return (
      <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup validationState={submitted && errors.has('devaddr') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('addbroadcastreq.address')}
            </ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={devaddr}
              placeholder={this.intlMsg.msg('addbroadcastreq.devaddr.placeholder')}
              onChange={e => this.handleChangeDevaddr(e)}
            />
            <ControlTips
              show={submitted && errors.has('devaddr')}
              message={this.intlMsg.errorMsg(errors.get('devaddr'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('appskey') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('addbroadcastreq.appskey.label')}
            </ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={appskey}
              placeholder={this.intlMsg.msg('addbroadcastreq.keys.placeholder')}
              onChange={e => this.handleChangeKeys('appskey', e)}
            />
            <ControlTips
              show={submitted && errors.has('appskey')}
              message={this.intlMsg.errorMsg(errors.get('appskey'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('nwkskey') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('addbroadcastreq.nwskey.label')}
            </ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={nwkskey}
              placeholder={this.intlMsg.msg('addbroadcastreq.keys.placeholder')}
              onChange={e => this.handleChangeKeys('nwkskey', e)}
            />
            <ControlTips
              show={submitted && errors.has('nwkskey')}
              message={this.intlMsg.errorMsg(errors.get('nwkskey'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('fcnt') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('addbroadcastreq.fcnt')}
            </ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={fcnt}
              onChange={e => this.handleChangeFcnt(e)}
            />
            <ControlTips
              show={submitted && errors.has('fcnt')}
              message={this.intlMsg.errorMsg(errors.get('fcnt'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <RichButton
              status={sentStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('submit'),
                style: 'primary',
                type: 'submit',
              }, {
                status: 'success',
                label: this.intlMsg.msg('submit.success'),
                style: 'success',
                timer: () => this.setState({ sentStatus: '' }),
              }, {
                status: 'failure',
                label: this.intlMsg.msg('submit.failure'),
                style: 'danger',
                timer: () => this.setState({ sentStatus: '' }),
              }]}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

AddBroadcastReqV2.propTypes = propTypes;

const mapStateToProps = state => ({
  sent: state.device.sendAddBroadcastReqV2,
});

const mapDispatchToProps = {
  sendCmd: deviceActions.sendAddBroadcastReqV2,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AddBroadcastReqV2));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/AddBroadcastReqV2.jsx